exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.left_sidebar[data-v-4b1cdf0b] {\n    width: 17%;\n    float: left;\n    border-right: 1px solid;\n    height: 100%;\n}\n.result[data-v-4b1cdf0b] {\n    margin-left: 10px;\n    width: 83%;\n}\n\n", ""]);

// exports
